import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=b7a658bc&scoped=true&"
import script from "./ClientPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a658bc",
  null
  
)

export default component.exports